import React from 'react';
import { Card, Avatar } from 'antd';
import styled from '@emotion/styled';
import { SoundFilled, VideoCameraFilled } from '@ant-design/icons';
import { FaRegCalendarAlt } from 'react-icons/fa';
import { capitalized } from '../../lib/capitilize';
import UserIcon from '../UI/UserIcon';
import { useTranslation } from 'react-i18next';

const StyledCard = styled(Card)`
  .ant-card-body {
    padding: 16px;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const SectionIcon = styled(Avatar)`
  background: #fff;
  border: 2px solid var(--productGray);
  color: var(--productGray);
`;

const Label = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: var(--productGray);
`;

const Value = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
`;

const SecondaryText = styled.p`
  margin: 0;
  font-size: 12px;
  color: var(--productGray);
`;

type Props = {
  clinicianName: string;
  clinicianType: string;
  date: string;
  callType: 'AUDIO' | 'VIDEO';
};

const BookingSummary: React.FC<Props> = ({ clinicianName, clinicianType, date, callType }) => {
  const { t } = useTranslation('common');
  return (
    <StyledCard>
      <Content>
        <Section>
          <UserIcon size={32} style={{ color: 'var(--productGray)' }} />
          <div>
            <Label>{t('Clinician')}</Label>
            <Value>{clinicianName}</Value>
            <SecondaryText>{clinicianType}</SecondaryText>
          </div>
        </Section>

        <Section>
          <SectionIcon size={32} icon={<FaRegCalendarAlt />} />
          <div>
            <Label>{t('Date & Time')}</Label>
            <Value>{date}</Value>
          </div>
        </Section>

        <Section>
          <SectionIcon size={32} icon={callType === 'AUDIO' ? <SoundFilled /> : <VideoCameraFilled />} />
          <div>
            <Label>{t('Appointment Type')}</Label>
            <Value>
              {capitalized(callType)} {t('Appointment')}
            </Value>
          </div>
        </Section>
      </Content>
    </StyledCard>
  );
};

export default BookingSummary;
